import { render, staticRenderFns } from "./fileUploadForm.vue?vue&type=template&id=5f6215a6&"
import script from "./fileUploadForm.vue?vue&type=script&lang=js&"
export * from "./fileUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports